<template>
  <div
    class="c-navigation-panel -responsive"
    :class="{ 'is-visible': isHighlightsPanelVisible }"
  >
    <div
      class="c-navigation-panel__content-container"
      @mousedown.prevent
    >
      <div
        class="c-navigation-panel__content"
        :class="{ 'is-visible': isHighlightsPanelVisible }"
      >
        <div class="o-container t-full">
          <div class="o-grid -xs-left -xs-no-gutter t-full">
            <div class="o-grid__item">
              <vSearchHighlightsContent
                :initial-context="initialContext"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import STORE_TYPES_SEARCH from '@/web/store/registered/search'
  import vSearchHighlightsContent from '@/web/components/header-search/search-highlights-content.vue'

  export default {
    components: {
      vSearchHighlightsContent
    },
    props: {
      initialContext: {
        type: String,
        default: ''
      }
    },
    computed: {
      ...mapGetters({
        isHighlightsPanelVisible: STORE_TYPES_SEARCH.GETTERS.GET_IS_HIGHLIGHTS_PANEL_VISIBLE
      })
    },
    methods: {
      ...mapMutations({
        setIsHighlightsPanelVisible: STORE_TYPES_SEARCH.MUTATIONS.SET_IS_HIGHLIGHTS_PANEL_VISIBLE
      })
    }
  }
</script>

<style lang="scss" scoped>
  .c-navigation-panel {
    height: 554px;
  }
</style>
